export const EMPTY_ARR: any = [];
export const EMPTY_MATRIX: any = {};
